import styled from 'styled-components'
import Typography from '../typography'

export const blockContainer = styled.div`
  ${({
    orangeDivider,
    quoteBlockTheme,
    theme,
    topPadding,
    bottomPadding,
    centerAlignment,
  }: any) => {
    let innerStyles = ``
    if (topPadding === 'Large') innerStyles += 'padding-top: 96px;'
    else if (topPadding === 'Small') innerStyles += 'padding-top: 64px;'
    else if (topPadding === 'None') innerStyles += 'padding-top: 0px;'
    if (bottomPadding === 'Large') innerStyles += 'padding-bottom: 96px;'
    else if (bottomPadding === 'Small') innerStyles += 'padding-bottom: 64px;'
    else if (bottomPadding === 'None') innerStyles += 'padding-bottom: 0;'

    let divider = ``
    if (orangeDivider) {
      divider += `
        .paragrapghBlock__Title_container:before {
          content: '';
          position: absolute;
          width: 160px;
          height: 4px;
          background: ${theme.webMktPalette.orange[50]};
        }
      `
    }

    let alignment = ``
    if (centerAlignment) {
      alignment += `
        text-align: center;
        .paragrapghBlock__Title_container {
          margin: 0 auto;
          &:before {
            left: 50%;
            transform: translateX(-50%);
          }
        }
      `
    }

    return `
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: ${
        quoteBlockTheme === 'Light'
          ? theme.webMktPalette.background.white
          : theme.webMktPalette.background.gray
      };
      box-sizing: border-box;
      ${innerStyles}
      ${divider}
      ${alignment}


      .ParagraphBlock__Container {
        margin: 64px 0;
        max-width: 632px;
        ${theme.breakpoints.down('sm')} {
          max-width: 533px;
        }
      }

      ul {
        list-style: disc;
      }


      a + span, .inline-formatter {
        display: inline;
      }

      .quote-container {
        background: ${
          quoteBlockTheme === 'Light'
            ? theme.webMktPalette.background.gray
            : theme.webMktPalette.background.white
        };
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 32px;
        position: relative;
        margin: 48px 0;
        letter-spacing: -0.5px;

        ${theme.breakpoints.down('xs')} {
          font-size: 20px;
          line-height: 32px;
        }
      }

      .is-quote {
        margin-top: 80px;
      }

      .is-quote:before {
        content: '';
        background-image: url("https://images.ctfassets.net/5965pury2lcm/6D8NmS3Zf7JZLkVIzD0UjL/97aa5dce32ab883531b4697ff3cf531e/heist-blog-blockquote-quotes.svg");
        background-repeat: no-repeat, repeat;
        position: absolute;
        width: 100%;
        height: 64px;
        top: -31px;
        left: 48px;
      }

      .is-quote > p:first-child {
        margin: 32px 0;
      }

      .is-quote > p:last-child {
        margin: 0;
      }
    `
  }}
`

export const blockTitle = styled(Typography)`
  white-space: pre-line;
  padding: 48px 0 32px 0;
`
